/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomQuestionnaireAnswer } from './CustomQuestionnaireAnswer';
import {
  CustomQuestionnaireAnswerFromJSON,
  CustomQuestionnaireAnswerFromJSONTyped,
  CustomQuestionnaireAnswerToJSON,
} from './CustomQuestionnaireAnswer';

/**
 * Adds nested create feature
 * @export
 * @interface CustomQuestionnaireAnswerSet
 */
export interface CustomQuestionnaireAnswerSet {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireAnswerSet
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireAnswerSet
   */
  useCase: number;
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireAnswerSet
   */
  questionnaire: number;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireAnswerSet
   */
  readonly createdBy: string;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireAnswerSet
   */
  readonly updatedBy: string;
  /**
   *
   * @type {Date}
   * @memberof CustomQuestionnaireAnswerSet
   */
  readonly createdAt: Date;
  /**
   *
   * @type {Date}
   * @memberof CustomQuestionnaireAnswerSet
   */
  readonly updatedAt: Date;
  /**
   *
   * @type {boolean}
   * @memberof CustomQuestionnaireAnswerSet
   */
  isDraft?: boolean;
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireAnswerSet
   */
  lastConfirmedStep?: number | null;
  /**
   *
   * @type {Array<CustomQuestionnaireAnswer>}
   * @memberof CustomQuestionnaireAnswerSet
   */
  answers: Array<CustomQuestionnaireAnswer>;
}

/**
 * Check if a given object implements the CustomQuestionnaireAnswerSet interface.
 */
export function instanceOfCustomQuestionnaireAnswerSet(value: object): value is CustomQuestionnaireAnswerSet {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  if (!('questionnaire' in value) || value['questionnaire'] === undefined) return false;
  if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
  if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
  if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
  if (!('answers' in value) || value['answers'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireAnswerSetFromJSON(json: any): CustomQuestionnaireAnswerSet {
  return CustomQuestionnaireAnswerSetFromJSONTyped(json, false);
}

export function CustomQuestionnaireAnswerSetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireAnswerSet {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    useCase: json['use_case'],
    questionnaire: json['questionnaire'],
    createdBy: json['created_by'],
    updatedBy: json['updated_by'],
    createdAt: new Date(json['created_at']),
    updatedAt: new Date(json['updated_at']),
    isDraft: json['is_draft'] == null ? undefined : json['is_draft'],
    lastConfirmedStep: json['last_confirmed_step'] == null ? undefined : json['last_confirmed_step'],
    answers: (json['answers'] as Array<any>).map(CustomQuestionnaireAnswerFromJSON),
  };
}

export function CustomQuestionnaireAnswerSetToJSON(
  value?: Omit<CustomQuestionnaireAnswerSet, 'id' | 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    use_case: value['useCase'],
    questionnaire: value['questionnaire'],
    is_draft: value['isDraft'],
    last_confirmed_step: value['lastConfirmedStep'],
    answers: (value['answers'] as Array<any>).map(CustomQuestionnaireAnswerToJSON),
  };
}
